/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ButtonTypes } from '@app/app/shared/styleguide/components/buttons/default/button.component';
import { LucideIconInput } from '@lucide/angular';

export type V3ContentCardView = 'grid' | 'list';

export const V3_CONTENT_CARD_GRADIENTS = [
  'linear-gradient(135deg, #ede9fe, #c4b5fd)',
  'linear-gradient(135deg, #eff6ff, #bfdbfe)',
  'linear-gradient(135deg, #ecfdf5, #6ee7b7)',
  'linear-gradient(135deg, #f5f3ff, #ddd6fe)',
  'linear-gradient(135deg, #fef9c3, #fde68a)',
  'linear-gradient(135deg, #fff1f2, #fecdd3)',
];

// Keyed by content id so the gradient travels with the card on reorder, instead of belonging to the grid slot.
// Case-insensitive so callers passing lowercased ids agree with callers passing raw ids.
export function v3ContentCardGradient(key: string | null | undefined, fallbackIndex = 0): string {
  if (!key) {
    return V3_CONTENT_CARD_GRADIENTS[fallbackIndex % V3_CONTENT_CARD_GRADIENTS.length];
  }
  const normalizedKey = key.toLowerCase();
  let hash = 0;
  for (let i = 0; i < normalizedKey.length; i++) {
    hash = (hash * 31 + normalizedKey.charCodeAt(i)) % 1000000007;
  }
  return V3_CONTENT_CARD_GRADIENTS[hash % V3_CONTENT_CARD_GRADIENTS.length];
}

export type V3ContentCardStatusTone = 'draft' | 'unpublished' | 'archived' | 'success' | 'warning' | 'neutral';

export interface V3ContentCardStatusBadge {
  label: string;
  tone: V3ContentCardStatusTone;
  icon?: LucideIconInput;
}

export interface V3ContentCardMetaEntry {
  icon?: LucideIconInput;
  text: string;
}

export interface V3ContentCardAction {
  label: string;
  type: ButtonTypes;
}

export interface V3ContentCardItem {
  uid: string;
  title: string;
  titleIsPlaceholder?: boolean;
  subtitle?: string;
  thumbnail?: string | null;
  gradient?: string | null;
  coverIcon?: LucideIconInput | null;
  typeLabel?: string;
  typeIcon?: LucideIconInput | null;
  progress?: number | null;
  gradeLabel?: string | null;
  gradePassing?: boolean;
  statusBadge?: V3ContentCardStatusBadge | null;
  meta?: V3ContentCardMetaEntry[];
  tags?: string[];
  accent?: 'teal';
}
